import { h } from 'preact';

import './HeroImage.scss';

export default () => {
    return (
        <div class="hero-image">
            <div class="hero-image__image"></div>
            <div class="hero-image__text-container">
                <p class="hero-image__headline">Dr. Béres-Deák Ügyvédi&nbsp;Iroda</p>
                <a class="hero-image__byline" target="_blank" rel="external,noopener" href={`https://maps.google.com/?q=${encodeURIComponent('3200 Gyöngyös, Május 1. lépcső 6.')}`}>3200&nbsp;Gyöngyös, Május&nbsp;1.&nbsp;lépcső&nbsp;6.</a>
                {/* <a href="tel:+36-30-214-7777" class="hero-image__byline">+36-30-214-7777</a> */}
                <p class="hero-image__like-button">
                    <iframe src="https://www.facebook.com/plugins/like.php?href=http%3A%2F%2Ffacebook.com%2Fberes-deak&width=88&layout=button_count&action=like&size=large&show_faces=false&share=false&height=28&appId" width="88" height="28" style="border:none;overflow:hidden;height:28px;" scrolling="no" frameborder="0" allowTransparency="true"></iframe>
                </p>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/HeroImage.js